import request from '@/utils/seftRequest';

// 根据号码查询账单信息
export function qryPayUrl(data) {
  return request('/whalecloud/cvbs/v1/qryPayUrl', {
    method: 'POST',
    body: data,
  });
}

// 图形验证码生成接口
export function genCaptcha() {
  return request('/ding/genCaptcha', {
    method: 'POST',
  });
}

// 根据号码查询账单信息
export function validCaptcha(data) {
  return request('/ding/validCaptcha', {
    method: 'POST',
    body: data,
  });
}

export function qryAllStates(params) {
  return request('/ding/custService/qryOssAddressListBsnl', {
    method: 'POST',
    body: params,
  });
}

export function qrySubsDetail(data) {
  return request('/ding/subsService/qrySubsDetailBsnl', {
    method: 'POST',
    body: data,
  });
}
